<main class="account-settings">
  <header class="settings-heading">
    <div>
      <h1>{{ 'account_settings_title' | translate }}</h1>
      <p>{{ 'account_settings_manage_profile_info' | translate }}</p>
    </div>
    <nav class="settings-tabs" aria-label="Account settings sections">
      <button [class.active]="activeSection === 'settings'"
              (click)="activeSection = 'settings'">{{ 'account_settings_tab_title' | translate }}
      </button>
      <button [class.active]="activeSection === 'connections'"
              (click)="activeSection = 'connections'">{{ 'account_settings_connections' | translate }}
      </button>
      <button [class.active]="activeSection === 'notifications'"
              (click)="selectNotifications()">{{ 'notification_settings_tab_title' | translate }}
      </button>
    </nav>
  </header>

  <div class="settings-layout">
    <aside class="settings-sidebar">
      <section class="identity">
        <div class="avatar">{{ initials }}</div>
        <div>
          <strong>{{ account.displayName || (account.firstName + ' ' + account.lastName) }}</strong><span>{{ account.username }}</span><span>{{ account.defaultEmail || account.emails?.[0]?.email }}</span>
        </div>
      </section>
      <section class="overview">
        <h2>{{ 'account_settings_account_overview' | translate }}</h2>
        <div><span>{{ 'account_settings_type' | translate }}</span><b>{{ accountTypeLabel }}</b></div>
        <div><span>{{ 'language_selection' | translate }}</span><b>{{ language }}</b></div>
        <div *ngFor="let membership of filteredGroupMemberships" class="membership-row">
          <span>{{ 'group_type_' + membership.type | translate }}</span>

          <b class="membership-name">
            {{ membership.displayName }}

            <a *ngIf="membership.type === 'ORGANIZATION' && membership.isAdmin"
               (click)="goToOrganization(membership.groupId)"
               href="javascript:void(0)"
               class="manage-org-link"
               [attr.aria-label]="'manage_organization' | translate">
              <i class="fa fa-cog" aria-hidden="true"></i>
            </a>
          </b>
        </div>
        <hr>
        <h2>{{ 'assetlibrary_modal_usage' | translate }}</h2>
        <small>{{ account.groupMemberships?.length || 0 }} {{ 'account_settings_groups_used' | translate }}</small>
        <div class="meter"><i [style.width.%]="(account.groupMemberships?.length || 0) * 20"></i></div>
        <small>{{ storageUsed | number }}B of {{ storageMax | number }}
          B {{ 'account_settings_storage_used'| translate }}</small>
        <div class="meter"><i [style.width.%]="storageUsed / storageMax * 100"></i></div>
        <div
          class="usage-pages">{{ sharedPages }} {{ 'account_settings_of' | translate }} {{ sharedPagesMax }} {{ 'account_settings_shared_pages' | translate }}
        </div>
      </section>
      <section class="sidebar-links">
        <h2>{{ 'account_settings_account_billing' | translate }}</h2>
        <p>{{ 'account_settings_manage_plan_billing' | translate }}</p>
        <div class="account-option" role="button" tabindex="0" (click)="showBillingDialog()"
             (keydown.enter)="showBillingDialog()" (keydown.space)="$event.preventDefault(); showBillingDialog()">
          <span class="account-option-icon"><i class="fas fa-puzzle-piece" aria-hidden="true"></i></span>
          <div>
            <b>{{ 'account_settings_account_type_billing' | translate }}</b><span>{{ 'account_settings_manage_plan_billing_short' | translate }}</span>
          </div>
          <aero-button [size]="ButtonSize.SLIM" [aeroStyle]="ButtonStyle.TEXT" icon="fas fa-chevron-right"
                       [label]="'account_settings_account_type_billing' | translate"></aero-button>
        </div>
        <div class="account-option" role="button" tabindex="0" (click)="applyPromoCode()"
             (keydown.enter)="applyPromoCode()" (keydown.space)="$event.preventDefault(); applyPromoCode()">
          <span class="account-option-icon"><i class="fas fa-percent" aria-hidden="true"></i></span>
          <div>
            <b>{{ 'account_settings_prepaid_promo' | translate }}</b><span>{{ 'account_settings_apply_promo' | translate }}</span>
          </div>
          <aero-button [size]="ButtonSize.SLIM" [aeroStyle]="ButtonStyle.TEXT" icon="fas fa-chevron-right"
                       [label]="'account_settings_prepaid_promo' | translate"></aero-button>
        </div>
        <div class="account-option" role="button" tabindex="0" (click)="joinGroup()"
             (keydown.enter)="joinGroup()" (keydown.space)="$event.preventDefault(); joinGroup()">
          <span class="account-option-icon"><i class="fas fa-puzzle-piece" aria-hidden="true"></i></span>
          <div>
            <b>{{ 'account_settings_memberships_join' | translate }}</b><span>{{ 'account_settings_manage_memberships' | translate }}</span>
          </div>
          <aero-button [size]="ButtonSize.SLIM" [aeroStyle]="ButtonStyle.TEXT" icon="fas fa-chevron-right"
                       [label]="'account_settings_memberships_join' | translate"></aero-button>
        </div>
        <div *ngIf="!isOrganizationMember" class="account-option danger" role="button" tabindex="0"
             (click)="deleteAccount()" (keydown.enter)="deleteAccount()"
             (keydown.space)="$event.preventDefault(); deleteAccount()">
          <span class="account-option-icon"><i class="fas fa-trash-alt" aria-hidden="true"></i></span>
          <div>
            <b>{{ 'account_settings_delete_account' | translate }}</b><span>{{ 'account_settings_permanently_remove_account' | translate }}</span>
          </div>
          <aero-button [size]="ButtonSize.SLIM" [aeroStyle]="ButtonStyle.ALERT" icon="fas fa-chevron-right"
                       [label]="'account_settings_delete_account' | translate"></aero-button>
        </div>
      </section>
    </aside>

    <div class="settings-panel">
      <ng-container *ngIf="activeSection === 'settings'">
    <div class="settings-content">
      <section class="settings-card profile-card">
        <div class="card-heading"><span class="card-icon"><i class="far fa-user" aria-hidden="true"></i></span>
          <h2>{{ 'account_settings_profile_information' | translate }}</h2>
          <small>{{ 'account_settings_manage_basic_details' | translate }}</small></div>
        <form #settingsForm="ngForm" (ngSubmit)="update()" novalidate>
          <div class="form-grid">
            <aero-input name="firstName" [label]="'account_settings_first_name' | translate" bulbValidationField
                        [(ngModel)]="account.firstName" [required]="true"
                        [disabled]="!canUpdateNames"></aero-input>
            <aero-input name="lastName" [label]="'account_settings_last_name' | translate" bulbValidationField
                        [(ngModel)]="account.lastName"
                        [disabled]="!canUpdateNames"></aero-input>
          </div>
          <div class="form-grid">
            <aero-input name="displayName" [label]="'account_settings_display_name' | translate" bulbValidationField
                        [(ngModel)]="account.displayName"></aero-input>
            <aero-input name="username" [label]="'account_settings_username' | translate"
                        [(ngModel)]="account.username" [required]="true" autocapitalize="off"
                        autocorrect="off" spellcheck="false" [minlength]="2" [maxlength]="30"
                        pattern="^[A-Za-z0-9_-]+$" autocomplete="off"
                        bulbValidationField bulbAjaxValidation="accountSettingsUsernameUnique"
                        [accountValidationExistingValue]="storedAccount.username"></aero-input>
          </div>
          <div class="form-grid">
            <aero-input name="password" [label]="'account_settings_new_password' | translate" type="password"
                        autocomplete="new-password" placeholder="******" bulbValidationField
                        [(ngModel)]="account.password"
                        [minlength]="12"></aero-input>
            <aero-input name="confirmPassword" [label]="'account_settings_confirm_password' | translate"
                        type="password" autocomplete="new-password" placeholder="******" bulbValidationField
                        [(ngModel)]="account.confirmPassword" [minlength]="12"
                        [bulbValidationFieldMatch]="account.password"></aero-input>
          </div>
          <div class="form-grid profile-metadata">
            <div class="profile-metadata-field">
              <label for="account-language">{{ 'language_selection' | translate }}</label>
              <aero-dropdown name="language" inputElementId="account-language" [choices]="languages"
                             [selectedOption]="account.language.toLowerCase()" (communicating)="changeLanguage($event)"
                             [placeholder]="'account_settings_language_placeholder' | translate"></aero-dropdown>
            </div>
            <div class="profile-readonly-field">
              <span class="profile-metadata-label">{{ 'account_settings_role' | translate }}</span>
              <strong>{{ account.position }}</strong>
            </div>
            <div *ngIf="account.position === 'STUDENT' && account.grade" class="profile-readonly-field">
              <span class="profile-metadata-label">{{ 'group_type_GRADE' | translate }}</span>
              <strong>
                {{ account.grade === 'POSTGRADUATE' ? ('grade_level_POSTGRADUATE' | translate) : account.grade }}
              </strong>
            </div>
          </div>
          <div class="card-actions">
            <aero-button type="button" [size]="ButtonSize.LARGER" [aeroStyle]="ButtonStyle.PRIMARY"
                         [label]="'button_update' | translate"
                         [disabled]="settingsForm.invalid || settingsForm.pristine"
                         (onClick)="update()"></aero-button>
          </div>
        </form>
      </section>

      <section class="settings-card email-card">
        <div class="card-heading">
          <span class="card-icon"><i class="far fa-envelope" aria-hidden="true"></i></span>
          <h2>{{ 'account_settings_email_addresses' | translate }}</h2>
          <small>{{ 'account_settings_email_addresses_info' | translate }}</small>
        </div>
        <bulb-account-emails [account]="account"></bulb-account-emails>
      </section>

      <section class="settings-card communication-card">
        <div class="card-heading">
          <span class="card-icon"><i class="far fa-comment" aria-hidden="true"></i></span>
          <h2>{{ 'account_settings_communication_options' | translate }}</h2>
          <small>{{ 'account_settings_communication_options_info' | translate }}</small></div>
        <div class="option-row">
          <span>{{ 'account_settings_marketing_opt_in' | translate }}</span>
          <aero-toggle [ngModel]="account.prefs?.marketing?.optIn" (ngModelChange)="toggleMarketing()"
                       inputId="marketing-opt-in-toggle"
                       [ariaLabel]="'account_settings_marketing_opt_in' | translate"></aero-toggle>
        </div>
      </section>

      <section *ngIf="isAdmin" class="settings-card mfa-card">
        <div class="card-heading">
          <span class="card-icon"><i class="fas fa-shield-alt" aria-hidden="true"></i></span>
          <h2>{{ 'account_settings_mfa' | translate }}</h2>
          <small *ngIf="!account.connections?.mfa">{{ 'account_settings_enable_mfa_description' | translate }}</small>
          <small *ngIf="account.connections?.mfa">{{ 'account_settings_refresh_mfa_description' | translate }}</small>
        </div>

        <div class="mfa-content">
          <div *ngIf="mfaQRCode && account.connections?.mfa" class="mfa-qr-code" style="margin-bottom: 1rem;">
            <img [src]="mfaQRCode" alt="MFA QR Code"/>
          </div>

          <div class="card-actions">
            <aero-button [size]="ButtonSize.LARGER"
                         [aeroStyle]="ButtonStyle.PRIMARY"
                         [label]="(account.connections?.mfa ? 'account_settings_refresh_mfa' : 'account_settings_enable_mfa') | translate"
                         (onClick)="enableOrRefreshMFA()">
            </aero-button>
          </div>
        </div>
      </section>

    </div>
      </ng-container>
    <div class="quick-actions-container">
      <section class="settings-card quick-actions">
        <div class="card-heading"><span class="card-icon">ϟ</span>
          <h2>{{ 'account_settings_quick_actions' | translate }}</h2>
          <small>{{ 'account_settings_frequently_used_actions' | translate }}</small></div>
        <div class="quick-grid">
          <div class="quick-action">
            <span class="quick-action-icon resume-icon"><i class="fas fa-file-alt" aria-hidden="true"></i></span>
            <div><b>{{ 'account_settings_resume_tab' | translate }}</b>
              <span>{{ resumeLabel }}</span></div>
            <aero-toggle *ngIf="!account.features.ResumeFeature.disabledByOrg" [ngModel]="isResumeEnabled"
                         (ngModelChange)="toggleResume()" inputId="resume-tab-toggle"
                         [ariaLabel]="'account_settings_resume_tab' | translate"></aero-toggle>
          </div>
          <div class="quick-action">
            <span class="quick-action-icon profile-icon"><i class="fas fa-globe" aria-hidden="true"></i></span>
            <div>
              <b>{{ 'account_settings_public_profile' | translate }}</b><span>{{ 'account_settings_allow_profile_search' | translate }}</span>
            </div>
            <aero-toggle
              [aeroTooltip]="'account_settings_org_disabled' | translate"
              [tooltipDisabled]="!(account.features.WebSearchIndexingAccountFeature.disabledByOrg && !account.features.PrivateProfileFeature.enabled)"
              [disabled]="account.features.WebSearchIndexingAccountFeature.disabledByOrg && !account.features.PrivateProfileFeature.enabled"
              [ngModel]="isPublicProfileEnabled" (ngModelChange)="togglePublicProfile()"
              inputId="public-profile-toggle"
              [ariaLabel]="'account_settings_public_profile' | translate"></aero-toggle>
          </div>
          <div class="quick-action">
            <span class="quick-action-icon badgr-icon"><i class="fas fa-shield-alt" aria-hidden="true"></i></span>

            <!-- Content when Badgr is NOT connected -->
            <ng-container *ngIf="!account.hasBadges">
              <div>
                <b class="badges">
                  {{ 'account_settings_link_badgr' | translate }}
                  <i class="far fa-info-circle"
                     [attr.aria-label]="'account_settings_badge_icon' | translate"
                     (click)="openBadgesInfoModal($event)"></i>
                </b>
                <span>{{ 'account_settings_connect_badges' | translate }}</span>
              </div>
              <aero-button [size]="ButtonSize.SLIM" [aeroStyle]="ButtonStyle.TEXT" icon="fas fa-chevron-right"
                           [label]="'account_settings_link_badgr' | translate"
                           (onClick)="redirectToBadgr()">
              </aero-button>
            </ng-container>

            <!-- Content when Badgr IS connected -->
            <ng-container *ngIf="account.hasBadges">
              <div>
                <b class="badges">
                  {{ 'account_settings_link_badgr' | translate }}
                  <i class="far fa-info-circle"
                     [attr.aria-label]="'account_settings_badge_icon' | translate"
                     (click)="openBadgesInfoModal($event)"></i>
                </b>
                <span>{{ 'badge_disconnect_button' | translate }}</span>
              </div>
              <aero-button [size]="ButtonSize.SLIM" [aeroStyle]="ButtonStyle.ALERT"
                           [label]="'badge_disconnect_button' | translate"
                           (onClick)="disconnectBadgr()">
              </aero-button>
            </ng-container>
          </div>
          <div class="quick-action" (click)="showParentAccountsDialog()">
            <span class="quick-action-icon family-icon"><i class="fas fa-users" aria-hidden="true"></i></span>
            <div>
              <b>{{ 'account_settings_parent_accounts' | translate }}</b><span>{{ 'account_settings_enable_manage_parent' | translate }}</span>
            </div>
            <aero-button [size]="ButtonSize.SLIM" [aeroStyle]="ButtonStyle.TEXT" icon="fas fa-chevron-right"
                         [label]="'account_settings_parent_accounts' | translate"></aero-button>
          </div>
        </div>
      </section>
      <div class="mobile-launch-wrapper" style="margin-top: 1.5rem;">
        <bulb-launch-button></bulb-launch-button>
      </div>
    </div>

  <section *ngIf="activeSection === 'notifications'" class="notifications-page">
    <section class="settings-card notification-card email-notification-card">
      <header class="notification-header">
        <span class="notification-icon"><i class="far fa-envelope" aria-hidden="true"></i></span>
        <h2>{{ 'account_settings_email' | translate }}</h2>
        <aero-toggle [(ngModel)]="account.notificationPref.email.enabled"
                     (ngModelChange)="setNotification('email', 'enabled', $event)"
                     inputId="email-notifications-toggle"
                     [ariaLabel]="'account_settings_email' | translate"></aero-toggle>
      </header>
      <div class="notification-body" *ngIf="notificationValue('email', 'enabled')">
        <div class="notification-subsection">
          <strong>{{ 'account_settings_email_frequency' | translate }}</strong>
          <label class="notification-control radio-control" *ngFor="let frequency of emailfrequencyType">
            <input type="radio" name="emailFrequency" [value]="frequency"
                   [checked]="account.notificationPref.email.frequency === frequency"
                   (change)="setFrequency(frequency)">
            <i></i><span>{{ ('notification_settings_email_frequency_' + frequency) | translate }}</span>
          </label>
        </div>
        <div class="notification-subsection" *ngIf="notificationKeys('email').length">
          <strong>{{ 'account_settings_receive_email_when' | translate }}</strong>
          <div class="notification-control" *ngFor="let key of notificationKeys('email')">
            <span>{{ ('notification_settings_' + key) | translate }}</span>
            <aero-toggle [(ngModel)]="account.notificationPref.email[key]"
                         (ngModelChange)="setNotification('email', key, $event)"
                         [inputId]="'email-' + key + '-toggle'"
                         [ariaLabel]="('notification_settings_' + key) | translate"></aero-toggle>
          </div>
        </div>
        <div class="group-notifications" *ngFor="let group of account.groupMemberships">
          <ng-container *ngIf="group.type === 'CLASS' || group.type === 'OTHER'">
            <strong>{{ 'account_settings_group' | translate }}: {{ group.displayName }}</strong>
            <div class="notification-control" *ngFor="let notification of groupNotifications"
                 [hidden]="!notification.show(group)">
              <span>{{ notification.code | translate }}</span>
              <aero-toggle *ngIf="group.notificationPrefs" [(ngModel)]="group.notificationPrefs.email[notification.field]"
                           (ngModelChange)="updateGroupNotification(group, notification, 'email', $event)"
                           [inputId]="'group-' + group.groupId + '-' + notification.field + '-toggle'"
                           [ariaLabel]="notification.code | translate"></aero-toggle>
            </div>
          </ng-container>
        </div>
      </div>
    </section>

    <section class="settings-card notification-card compact-notification-card"
             *ngIf="smsNotificationOptionsEnabled"
             [class.bulb-notification-inactive]="account.features?.SMSFeature?.enabled === false">
      <header class="notification-header">
        <span class="notification-icon"><i class="fas fa-mobile-alt" aria-hidden="true"></i></span>
        <h2>{{ 'account_settings_sms' | translate }}</h2>
        <aero-toggle [(ngModel)]="account.notificationPref.sms.enabled"
                     (ngModelChange)="setNotification('sms', 'enabled', $event)"
                     inputId="sms-notifications-toggle"
                     [ariaLabel]="'account_settings_sms' | translate"></aero-toggle>
      </header>
      <div class="notification-body" *ngIf="notificationValue('sms', 'enabled')">
        <label class="notification-phone">{{ 'account_settings_phone_number' | translate }}<input bulbPhoneInput
                                                                                                  [(ngModel)]="account.phoneNumber"
                                                                                                  name="phoneNumber"></label>
        <aero-button [size]="ButtonSize.SLIM" [aeroStyle]="ButtonStyle.PRIMARY" labelCode="button_update"
                     (onClick)="updatePhoneNumber()"></aero-button>
      </div>
    </section>

    <section class="settings-card notification-card compact-notification-card"
             *ngIf="pushNotificationOptionsEnabled"
             [class.bulb-notification-inactive]="account.features?.PushFeature?.enabled === false">
      <header class="notification-header">
        <span class="notification-icon"><i class="far fa-bell" aria-hidden="true"></i></span>
        <h2>{{ 'account_settings_web_browser_push' | translate }}</h2>
        <aero-toggle [(ngModel)]="account.notificationPref.pushNotification.enabled"
                     (ngModelChange)="setNotification('pushNotification', 'enabled', $event)"
                     inputId="push-notifications-toggle"
                     [ariaLabel]="'account_settings_web_browser_push' | translate"></aero-toggle>
      </header>
      <div class="notification-body" *ngIf="notificationValue('pushNotification', 'enabled')">
        <div class="notification-subsection" *ngIf="notificationKeys('pushNotification').length">
          <strong>{{ 'account_settings_receive_notifications_when' | translate }}</strong>
          <div class="notification-control" *ngFor="let key of notificationKeys('pushNotification')">
            <span>{{ ('notification_settings_' + key) | translate }}</span>
            <aero-toggle [(ngModel)]="account.notificationPref.pushNotification[key]"
                         (ngModelChange)="setNotification('pushNotification', key, $event)"
                         [inputId]="'push-' + key + '-toggle'"
                         [ariaLabel]="('notification_settings_' + key) | translate"></aero-toggle>
          </div>
        </div>
      </div>
    </section>
<!--    <button class="text-button notifications-back"-->
<!--            (click)="activeSection = 'settings'">{{ 'account_settings_back_to_settings' | translate }}-->
<!--    </button>-->
  </section>
  <section *ngIf="activeSection === 'connections'" class="connections-page">
    <section class="settings-card connections-card">
      <div class="card-heading">
        <span class="card-icon"><i class="fas fa-link" aria-hidden="true"></i></span>
        <h2>{{ 'account_settings_connections' | translate }}</h2>
        <small>{{ 'account_settings_connect_external_accounts' | translate }}</small>
      </div>

      <div class="connections-grid">
        <div *ngFor="let item of connectionProviders" class="connection-group-cell">

          <div class="connection-row">
            <span>{{ item.label | translate }}</span>
            <button *ngIf="canConnect(item.key) && !isOrgAdminSwitchUserClient"
                    type="button"
                    class="text-button"
                    (click)="connect(connectionAuthType(item.key))">
              {{ 'account_settings_connect' | translate }}
            </button>
          </div>

          <div *ngFor="let connection of account?.connections?.[item.key]" class="connection-row">
            <span class="connection-identifier">{{ getConnectionIdentifier(connection) }}</span>
            <button *ngIf="canConnect(item.key) && !isOrgAdminSwitchUserClient"
                    type="button"
                    class="text-button"
                    [class.bulb-cannot-disconnect]="connection.createdVia === 'SYNC'"
                    (click)="disconnect(item.key, connection)">
              {{ 'account_settings_disconnect' | translate }}
            </button>
          </div>

        </div>
      </div>

      <button type="button" class="info-link" (click)="connectionInfo()">
        {{ 'account_settings_connection_info' | translate }}
      </button>
    </section>
  </section>
    </div>
  </div>
</main>
